import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ChangeLogEntries } from "./ChangeLog";

export function EditHistoryDialog({ line, onClose }) {
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-lg max-h-[80vh] overflow-y-auto" data-testid="line-history-dialog">
        <DialogHeader>
          <DialogTitle>
            Change Log — {line.list_id} · Line #{line.line_no}
          </DialogTitle>
        </DialogHeader>
        {(line.edit_history || []).length === 0 ? (
          <p className="text-sm text-slate-400 py-6 text-center">No edits recorded for this line.</p>
        ) : (
          <ChangeLogEntries history={line.edit_history} />
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="line-history-close-button">Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
